import { useContext } from 'react';
import { Container } from 'react-bootstrap';

import SearchLicencesProvider, { SearchLicencesContext } from '../SearchLicensesContext';
import AppBreadcrumb from '../../../components/common/breadcrumb/AppBreadcrumb';
import { PageWrapper } from '../../../components/styles/Page.styled';
import DetailsView from '../../../components/searchLicenses/detailsView/DetailsView';

function LicensesDetails(props) {
  return (
    <SearchLicencesProvider componentProps={props}>
      <LicensesDetailsContainer />
    </SearchLicencesProvider>
  );
}

function LicensesDetailsContainer() {
  const { viewedLicenseId } = useContext(SearchLicencesContext);

  return (
    <Container>
      <AppBreadcrumb
        mainPage="Hemp Licenses"
        mainPageLink="/search-licenses"
        viewedLicenseId={viewedLicenseId}
      />
      <PageWrapper>
        <DetailsView />
      </PageWrapper>
    </Container>
  );
}

export default LicensesDetails;
